<script>
  import AXHR from "./js/axhr.js";
  import { session } from "./js/store.js";
  import { onInterval } from "./js/intervall.js";
  import format from "number-format.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  export let timeInterval = 20000;
  let resultpoints;
  function loadpointsData(endpoint, token) {
    var data = {
      points: 700,
    };
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        resultpoints = response.data.points;
      })
      .catch(function (error) {
        resultpoints = 0;
      });
  }
  const startLoadPointsData = loadpointsData(
    sessions.api + "/points/me",
    sessions.token
  );
  onInterval(() => {
    loadpointsData(sessions.api + "/points/me", sessions.token);
  }, timeInterval);

  let resultrb;
  function loadrbData(endpoint, token) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    AXHR(config)
      .then(function (response) {
        resultrb = response.data.length;
      })
      .catch(function (error) {
        resultrb = 0;
      });
  }
  const startLoadrbData = loadrbData(sessions.api + "/rb", sessions.token);
  onInterval(() => {
    loadrbData(sessions.api + "/rb", sessions.token);
  }, timeInterval);

  let resultua;
  function loaduaData(endpoint, token) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    AXHR(config)
      .then(function (response) {
        resultua = response.data.total;
      })
      .catch(function (error) {
        resultua = 0;
      });
  }
  const startLoaduaData = loaduaData(
    sessions.api +
      "/rb/" +
      sessions.routeractive.id +
      "/ip-hotspot-active/count",
    sessions.token
  );
  onInterval(() => {
    loaduaData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-active/count",
      sessions.token
    );
  }, timeInterval);

  let resultuser;
  function loaduserData(endpoint, token) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    AXHR(config)
      .then(function (response) {
        resultuser = response.data.total;
      })
      .catch(function (error) {
        resultuser = 0;
      });
  }
  const startLoaduserData = loaduserData(
    sessions.api + "/rb/" + sessions.routeractive.id + "/ip-hotspot-user/count",
    sessions.token
  );
  onInterval(() => {
    loaduserData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-user/count",
      sessions.token
    );
  }, timeInterval);
</script>

<div class="relative">
  <div class="grid grid-cols-1 gap-3 p-0 lg:grid-cols-2 xl:grid-cols-4">
    <!-- Value card -->
    <div
      class="flex items-center justify-between p-4 bg-white rounded-md shadow"
    >
      <div>
        <h6
          class="text-xs font-medium leading-none tracking-wider text-gray-500 uppercase"
        >
          Point
        </h6>
        <span class="text-xl font-semibold">
          {#if resultpoints}
            {format("#.##0,", resultpoints)}
          {:else}
            -
          {/if}</span
        >
      </div>
      <div>
        <span>
          <svg
            class="w-12 h-12 text-gray-400 dark:text-primary-dark"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- Orders card -->
    <div
      class="flex items-center justify-between p-4 bg-white rounded-md shadow"
    >
      <div>
        <h6
          class="text-xs font-medium leading-none tracking-wider text-gray-500 uppercase"
        >
          Server
        </h6>
        <span class="text-xl font-semibold">
          {#if resultrb}
            {format("#.##0,", resultrb)}
          {:else}
            -
          {/if}</span
        >
      </div>
      <div>
        <span>
          <svg
            class="w-12 h-12 text-gray-400 dark:text-primary-dark"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
            />
          </svg></span
        >
      </div>
    </div>

    <!-- Users card -->
    <div
      class="flex items-center justify-between p-4 bg-white rounded-md shadow"
    >
      <div>
        <h6
          class="text-xs font-medium leading-none tracking-wider text-gray-500 uppercase"
        >
          Active User (Active server)
        </h6>
        <span class="text-xl font-semibold"
          >{#if resultua}
            {format("#.##0,", resultua)}
          {:else}
            -
          {/if}</span
        >
      </div>
      <div>
        <span>
          <svg
            class="w-12 h-12 text-gray-300 dark:text-primary-dark"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- Tickets card -->
    <div
      class="flex items-center justify-between p-4 bg-white rounded-md shadow"
    >
      <div>
        <h6
          class="text-xs font-medium leading-none tracking-wider text-gray-500 uppercase"
        >
          Users (Active server)
        </h6>
        <span class="text-xl font-semibold"
          >{#if resultuser}
            {format("#.##0,", resultuser)}
          {:else}
            -
          {/if}</span
        >
      </div>
      <div>
        <span>
          <svg
            class="w-12 h-12 text-gray-300 dark:text-primary-dark"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</div>
